import type { ParticipantTaskTemplate } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown, FaPencilAlt, FaTrash } from 'react-icons/fa';
import { showModal } from '../../../components/generic/Modal';
import { ParticipantTaskTemplateDeleteModal } from './ParticipantTaskTemplateDeleteModal';
import { ParticipantTaskTemplateEditModal } from './ParticipantTaskTemplateEditModal';

interface Props {
  taskTemplate: ParticipantTaskTemplate;
}

export const ParticipantTaskTemplateActionMenu = (props: Props) => {
  const { taskTemplate } = props;

  return (
    <ChakraV3.Menu.Root>
      <ChakraV3.Menu.Trigger>
        <ChakraV3.Button variant='plain' size='sm'>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() => showModal(ParticipantTaskTemplateEditModal, { taskTemplate })}
            value='edit'
          >
            <FaPencilAlt />
            Edit
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantTaskTemplateDeleteModal, {
                participantTaskTemplate: taskTemplate,
              })
            }
            value='delete'
            color='danger'
          >
            <FaTrash />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
